import React from "react"
import styled from "styled-components"

import { minD, maxD } from "../../../../assets/styles/helpers/devices"
import { UnstyledList } from "../../common/essentials"
import { NavElement } from "./NavElement"
import LanguageSwitcher from "../../../language-switcher/language-switcher"

const NavElementsContainer = styled.div`
  @media ${minD.tabletL} {
    margin-left: auto;
    margin-right: 10px;
  }

  @media ${maxD.tabletL} {
    --nav-top-padding: 105px;

    position: fixed;
    width: 100vw;
    height: 100vh;

    top: 0;
    left: 0;
    z-index: -2;

    padding: var(--nav-top-padding) calc((100% - 690px) / 2) 0;
    background-color: #fff;

    transform: ${({ isMobileActive }) =>
      isMobileActive ? "translateX(0)" : "translateX(-100%)"};
    transition: transform 800ms cubic-bezier(0.19, 1, 0.22, 1);
  }

  @media ${maxD.tablet} {
    padding: var(--nav-top-padding) calc((100% - 500px) / 2) 0;
  }

  @media ${maxD.mobileL} {
    --nav-top-padding: 95px;

    padding: var(--nav-top-padding) 25px 0;
  }
`

const NavElements = styled(UnstyledList)`
  @media ${minD.tabletL} {
    position: relative;
    display: flex;
    justify-content: center;

    padding: 0 10px;
  }

  @media ${minD.laptop} {
    padding-left: 60px;
    padding-right: 0;
  }

  @media ${maxD.tabletL} {
    height: calc(100vh - var(--nav-top-padding));
    padding-bottom: calc(var(--nav-top-padding) * 0.5);
    overflow: auto;
  }
`

const MobileLanguageSwitcher = styled.li`
  @media ${minD.tabletL} {
    display: none;
  }

  @media ${maxD.tabletL} {
    display: flex;
    justify-content: flex-start;
    margin-top: 2rem;

    > * {
      transform: scale(1.1);
      transform-origin: left center;
    }
  }
`

const NavList = ({ isActive, items, pageContext }) => (
  <NavElementsContainer isMobileActive={isActive}>
    <NavElements>
      {items &&
        items.length !== 0 &&
        items.map(
          item =>
            !item.parentId && <NavElement key={item.id} {...item} />
        )}
      <MobileLanguageSwitcher>
        <LanguageSwitcher pageContext={pageContext} />
      </MobileLanguageSwitcher>
    </NavElements>
  </NavElementsContainer>
)

export { NavList }
